import ManageFishScreen from '../../screens/ManageFish/ManageFishScreen'
import { connect } from 'react-redux'

const mapStateToProps = ({ fish }) => {
  return { fish }
}

export default connect(mapStateToProps)(ManageFishScreen)


// WEBPACK FOOTER //
// ./src/containers/ManageFish/ManageFish.js